import axios from "axios";

const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL;
const isLocalFrontend =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);
const BACKEND_URL = isLocalFrontend ? "http://127.0.0.1:8000" : configuredBackendUrl;
export const API = `${BACKEND_URL}/api`;
const AUTH_TOKEN_KEY = "mapio_auth_token";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY);

export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
  } else {
    localStorage.removeItem(AUTH_TOKEN_KEY);
  }
};

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const resolveAssetUrl = (url) => {
  if (!url) return url;
  if (/^https?:\/\//i.test(url) || url.startsWith("data:")) return url;
  return `${BACKEND_URL}${url}`;
};

export const fetchEvents = async (category) => {
  const params = { status: "approved" };
  if (category && category !== "All") params.category = category;
  const { data } = await api.get("/events", { params });
  return data;
};

export const createEvent = async (payload) => {
  const { data } = await api.post("/events", payload);
  return data;
};

export const signUp = async (payload) => {
  const { data } = await api.post("/auth/signup", payload);
  setAuthToken(data.token);
  return data;
};

export const login = async (payload) => {
  const { data } = await api.post("/auth/login", payload);
  setAuthToken(data.token);
  return data;
};

export const fetchCurrentUser = async () => {
  const { data } = await api.get("/auth/me");
  return data;
};

export const logout = async () => {
  try {
    await api.post("/auth/logout");
  } finally {
    setAuthToken(null);
  }
};

export const updateProfile = async (payload) => {
  const { data } = await api.patch("/profile", payload);
  return data;
};

export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await api.post("/uploads", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return resolveAssetUrl(data.url);
};

export const fetchWallet = async () => {
  const { data } = await api.get("/wallet");
  return data;
};

export const createMoTopUpOrder = async (amountMo) => {
  const { data } = await api.post("/wallet/topup/order", { amount_mo: amountMo });
  return data;
};

export const verifyMoTopUp = async (payload) => {
  const { data } = await api.post("/wallet/topup/verify", payload);
  return data;
};

export const joinEvent = async (eventId, userName) => {
  const { data } = await api.post(`/events/${eventId}/join`, { user_name: userName });
  return data;
};

export const reportEvent = async (eventId) => {
  const { data } = await api.post(`/events/${eventId}/report`);
  return data;
};

export const fetchMessages = async (eventId) => {
  const { data } = await api.get(`/events/${eventId}/messages`);
  return data;
};

export const sendMessage = async (eventId, payload) => {
  const { data } = await api.post(`/events/${eventId}/messages`, payload);
  return data;
};

// Admin
export const adminFetchEvents = async (status) => {
  const params = {};
  if (status) params.status = status;
  const { data } = await api.get("/admin/events", { params });
  return data;
};

export const adminUpdateStatus = async (eventId, status) => {
  const { data } = await api.patch(`/admin/events/${eventId}/status`, { status });
  return data;
};

export const adminDeleteEvent = async (eventId) => {
  const { data } = await api.delete(`/admin/events/${eventId}`);
  return data;
};
